module.exports = __webpack_public_path__ + "static/media/fancy-plants.67f37bd0.png";